<template>
    <button
        @click="show = !show"
        class="p-3 flex items-center justify-center rounded border-2 hover:bg-gray-100"
    >
        <icon type="filter" class="w-4 h-4" />
    </button>

    <modal v-model="show">
        <h2 class="heading-2">Filter Markets</h2>

        <form
            :action="url"
            class="w-full max-h-full flex flex-col gap-4"
        >
            <select-input
                v-model="countrySlug"
                label="Country"
            >
                <option value="">Please choose one</option>
                <option v-for="country in countries" :key="country.id" :value="country.slug">{{ country.name }}</option>
            </select-input>

            <select-input
                v-if="selectedCountry.has_regions"
                v-model="regionSlug"
                label="Region"
            >
                <option value="">Please choose one</option>
                <option v-for="region in selectedCountry.regions" :key="region.id" :value="region.slug">{{ region.name }}</option>
            </select-input>
        </form>

        <template #footer="{ close }">
           <div class="flex space-x-4">
               <button
                    @click.prevent="close(), reset()"
                    class="flex-1 px-4 py-2 border-2 rounded tracking-wider font-semibold text-gray-900 hover:bg-gray-200"
                >
                    Close
                </button>
               <button
                    @click.prevent="submit"
                    class="btn btn-green flex-1"
                >
                    Submit
                </button>
           </div>
        </template>
    </modal>
</template>

<script setup>
import { computed, ref, watch } from 'vue'
import { stringify } from 'qs'
import { pickBy } from 'lodash'

const props = defineProps({
    url: {
        type: String,
        required: true,
    },
    filters: {
        type: Object,
        required: true,
    },
    countries: {
        type: Array,
        required: true,
    }
})

const countrySlug = ref(props.filters.country ?? '')
const regionSlug = ref(props.filters.region ?? '')
const show = ref(false)
watch(countrySlug, value => {
    if(value == '') return
    regionSlug.value = ''
})

const selectedCountry = computed({
    get: () => props.countries.find(country => country.slug == countrySlug.value) ?? {},
    set: value => countrySlug.value = value
})

const query = computed(() => stringify(pickBy({ filters: pickBy({ country: countrySlug.value, region: regionSlug.value })})))

const submit = () => {
    window.location.assign(props.url + '?' + query.value)
}

const reset = () => {
    countrySlug.value = props.filters.country ?? ''
}
</script>
